import React from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';
import Detail from './Detail';

const WorkReport = () => {
  document.title = "Судалгааны тайлан";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Судалгааны тайлан" breadcrumbItem="Судалгааны тайлан" />
          <Row>
            <Detail />
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default WorkReport;